import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { CircularProgress } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
    openDrawer,
    setCurrentDrawerId,
    setCurrentEntity,
    setCurrentOperation
} from 'common/components/EditDrawer/editDrawerSlice';
import { UserProfileEntityContainer } from 'common/components/UserProfileEntityContainer/UserProfileEntityContainer';
import { Roles } from 'common/constants/roles';
import { usePalmButtonEvaluator } from 'common/hooks/usePalmButtonEvaluator';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { fetchIdentitiesById } from 'common/services/api/Identities/Identities.thunk';
import {
    DrawerEntitiesNames,
    Operations
} from 'common/types/TypeDefs';
import { DrawerIDs } from 'common/utils/DrawerIDs';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

import { UserProfileIdentitiesDrawer } from './components/UserProfileIdentitiesDrawer';
import { UserProfileIndetitiesList } from './components/UserProfileIdentitiesList';
import { selectIsProcessing,selectUserProfiles } from './userProfileIdentitiesSlice';

const CONTAINER_INLINE_STYLES = {
    backgroundColor: 'background.paper',
    borderRadius: '4px',
    border: 1,
    borderColor: 'info.dark',
    flexBasis: '66.66%',
    height: 'max-content',
    width: '100%'
};

export function UserProfileIdentities() {
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const shouldDisableLinkButton = usePalmButtonEvaluator([ Roles.Admin ]);
    const userProfiles = useAppSelector(selectUserProfiles);
    const processing = useAppSelector(selectIsProcessing);
    const { userId = '' } = useParams();

    useEffect(() => {
        dispatch(fetchIdentitiesById({ userId }))
            .catch((error) => {
                handleListFetchError(extractStatusCode(error.message), 'Identities', enqueueSnackbar);
            });
    }, []);

    const handleCreateButtonClick = () => {
        dispatch(setCurrentOperation(Operations.Link));
        dispatch(setCurrentEntity(DrawerEntitiesNames.UserIdentities));
        dispatch(setCurrentDrawerId(DrawerIDs.UserProfileIdentities));
        dispatch(openDrawer());
    };

    const userProfileIdentityProvidersToRender = (processing ? <CircularProgress color='primary'/> :
        <UserProfileIndetitiesList data={userProfiles}/>
    );

    return (
        <UserProfileEntityContainer
            title='Identities'
            isCreateButtonDisabled={shouldDisableLinkButton}
            shouldShowCreateButton={true}
            containerInlineStyles={CONTAINER_INLINE_STYLES}
            createButtonHandler={handleCreateButtonClick}
            includeRefreshButton={true}
            testId='link-identity'
        >
            <UserProfileIdentitiesDrawer />
            {userProfileIdentityProvidersToRender}
        </UserProfileEntityContainer>
    );
}
